module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "validate-content",
    class: {
      'bodyfont-unauth': !_vm.user
    }
  }, [_c('div', {
    staticClass: "col-md-12 bg-white"
  }, [_c('div', {
    staticClass: "main-content emailrules"
  }, [_c('h2', {
    staticClass: "heading"
  }, [_vm._v("\n                    Too many Emails? Let's change that!\n                ")]), _vm._v(" "), _c('h2', [_vm._v("Email Preferences")]), _vm._v(" "), _c('checkbox', {
    staticClass: "margin-left",
    attrs: {
      "value": _vm.userObj.isOptOutTeaser
    },
    model: {
      value: (_vm.userObj.isOptOutTeaser),
      callback: function($$v) {
        _vm.$set(_vm.userObj, "isOptOutTeaser", $$v)
      },
      expression: "userObj.isOptOutTeaser"
    }
  }, [_c('span', {
    staticClass: "checkboxcontent"
  }, [_c('span', [_c('strong', [_vm._v("Unsubscribe from TONE Teasers")])]), _c('span', {
    staticClass: "smpreferences"
  }, [_c('small', [_vm._v(" Twice a week email with videos selected specifically for you")])])])]), _vm._v(" "), _c('checkbox', {
    staticClass: "margin-left",
    attrs: {
      "value": _vm.userObj.isOptOutTakeaways
    },
    model: {
      value: (_vm.userObj.isOptOutTakeaways),
      callback: function($$v) {
        _vm.$set(_vm.userObj, "isOptOutTakeaways", $$v)
      },
      expression: "userObj.isOptOutTakeaways"
    }
  }, [_c('span', {
    staticClass: "checkboxcontent"
  }, [_c('span', [_c('strong', [_vm._v("Unsubscribe from TONE Takeaways")])]), _c('span', {
    staticClass: "smpreferences"
  }, [_c('small', [_vm._v(" Follow up email with key lessons once you have watched a video")])])])]), _vm._v(" "), _c('checkbox', {
    staticClass: "margin-left",
    attrs: {
      "value": _vm.userObj.isOptOutContentEmail
    },
    model: {
      value: (_vm.userObj.isOptOutContentEmail),
      callback: function($$v) {
        _vm.$set(_vm.userObj, "isOptOutContentEmail", $$v)
      },
      expression: "userObj.isOptOutContentEmail"
    }
  }, [_c('span', {
    staticClass: "checkboxcontent"
  }, [_c('span', [_c('strong', [_vm._v("Unsubscribe from Content Emails")])]), _c('span', {
    staticClass: "smpreferences"
  }, [_c('small', [_vm._v(" Event reminders, calendar invites, series launches and video blogs")])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('button', {
    staticClass: "btn formButton btn-block",
    attrs: {
      "disabled": _vm.spinner
    },
    on: {
      "click": function($event) {
        return _vm.updatePrefrences()
      }
    }
  }, [_vm._v("\n                    Update Preferences\n                    "), _c('spinner', {
    staticClass: "btn-spinner",
    attrs: {
      "size": "lg"
    },
    model: {
      value: (_vm.spinner),
      callback: function($$v) {
        _vm.spinner = $$v
      },
      expression: "spinner"
    }
  })], 1)])], 1)])])
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53ae6613"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/EmailRules.vue